export default {
  notifyList: state => state.notifyList
}
